import { render, staticRenderFns } from "./LogOutPage.vue?vue&type=template&id=8fb393d6"
import script from "./LogOutPage.vue?vue&type=script&lang=ts"
export * from "./LogOutPage.vue?vue&type=script&lang=ts"
import style0 from "./LogOutPage.vue?vue&type=style&index=0&id=8fb393d6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports